import { makeStyles } from 'e100-react-components';

import { TypographyProps } from './ui';

interface Props extends Pick<
  TypographyProps,
  'variant' | 'textAlign'
> {}

export const useStyles = makeStyles(({ typography }) => ({
  root: ({ variant, textAlign }: Props) => {
    // @ts-ignore
    const result = {
      overline: {
        fontSize: 11,
        lineHeight: `${16}px`,
        fontWeight: Number(typography.fontWeightMedium),
        textTransform: 'uppercase' as any
      },
      caption: {
        fontSize: 11,
        lineHeight: `${16}px`,
        fontWeight: Number(typography.fontWeightMedium),
      },
      button: {
        fontSize: 13,
        lineHeight: `${20}px`,
        fontWeight: Number(typography.fontWeightBold),
        textTransform: 'uppercase' as any
      },
      subtitle1: {
        fontSize: 16,
        lineHeight: `${24}px`,
        fontWeight: Number(typography.fontWeightMedium)
      },
      subtitile2: {
        fontSize: 14,
        lineHeight: `${20}px`,
        fontWeight: Number(typography.fontWeightMedium)
      },
      body1: {
        fontSize: 16,
        lineHeight: `${24}px`,
        fontWeight: Number(typography.fontWeightRegular)
      },
      body2: {
        fontSize: 14,
        lineHeight: `${20}px`,
        fontWeight: Number(typography.fontWeightRegular)
      },
      h1: {
        fontSize: 60,
        lineHeight: `${72}px`,
        fontWeight: Number(typography.fontWeightRegular)
      },
      h2: {
        fontSize: 48,
        lineHeight: `${56}px`,
        fontWeight: Number(typography.fontWeightRegular)
      },
      h3: {
        fontSize: 30,
        lineHeight: `${36}px`,
        fontWeight: Number(typography.fontWeightRegular)
      },
      h4: {},
      h5: {
        fontSize: 21,
        lineHeight: `${24}px`,
        fontWeight: Number(typography.fontWeightMedium)
      },
      h6: {
        fontSize: 18,
        lineHeight: `${24}px`,
        fontWeight: Number(typography.fontWeightMedium)
      }
    }[variant || ''] || {}

    return {
      ...result,
      textAlign: textAlign || '' as any
    };
  }
}));
